/* משק בולוקן – תנועה, שאלון, רמזי גודל */
(function () {
  if (window.__bkInit) { if (window.__bkScan) window.__bkScan(); return; }
  window.__bkInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('bk-js');

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function initCard(form) {
    if (form.__bk) return; form.__bk = 1;
    var hint = form.querySelector('[data-bk-hint]');
    if (!hint) return;
    var first = form.querySelector('input[name="id"]:checked');
    if (first) { hint.textContent = first.getAttribute('data-hint') || ''; }
    hint.classList.add('is-on');
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'id') return;
      var t = e.target.getAttribute('data-hint') || '';
      hint.classList.remove('is-on');
      setTimeout(function () { hint.textContent = t; hint.classList.add('is-on'); }, reduce ? 0 : 140);
    });
  }

  function initQuiz(q) {
    if (q.__bk) return; q.__bk = 1;
    var out = q.querySelector('[data-bk-result]');
    q.addEventListener('change', function () {
      var a = q.querySelector('input[data-q="1"]:checked');
      var b = q.querySelector('input[data-q="2"]:checked');
      if (!a || !b || !out) return;
      var s = parseInt(a.value, 10) + parseInt(b.value, 10);
      var key = s > 0 ? 'kor' : (s < 0 ? 'arb' : 'pair');
      q.querySelectorAll('[data-bk-res]').forEach(function (r) { r.hidden = r.getAttribute('data-bk-res') !== key; });
      out.hidden = false;
      out.classList.remove('is-in'); void out.offsetWidth; out.classList.add('is-in');
    });
  }

  function scan(root) {
    root = root || document;
    root.querySelectorAll('[data-bk-reveal]:not(.is-in)').forEach(function (el) {
      if (!io || reduce) el.classList.add('is-in'); else io.observe(el);
    });
    root.querySelectorAll('form[data-bk-card]').forEach(initCard);
    root.querySelectorAll('[data-bk-quiz]').forEach(initQuiz);
  }
  window.__bkScan = scan;

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bk-ticker-toggle]');
    if (t) {
      var box = t.closest('.bk-ticker');
      var paused = box.classList.toggle('is-paused');
      t.setAttribute('aria-pressed', paused ? 'true' : 'false');
      return;
    }
    var a = e.target.closest && e.target.closest('[data-bk-goto]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('data-bk-goto')) || document.querySelector('.bk-var__grid');
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    el.classList.remove('bk-flash'); void el.offsetWidth; el.classList.add('bk-flash');
    var btn = el.querySelector('button, .bk__btn');
    if (btn) setTimeout(function () { btn.focus({ preventScroll: true }); }, reduce ? 0 : 600);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
